import { createIcon, IconColors } from './icon-utils';

export const CommentingIcon = createIcon({
  fill: IconColors.DarkGrey,
  path: 'M8 18.5l3.2-2.4c.087-.065.192-.1.3-.1h7c.276 0 .5-.224.5-.5v-10c0-.276-.224-.5-.5-.5h-13c-.276 0-.5.224-.5.5v10c0 .276.224.5.5.5h2c.276 0 .5.224.5.5v2zM7 17H5.5c-.828 0-1.5-.672-1.5-1.5v-10C4 4.672 4.672 4 5.5 4h13c.828 0 1.5.672 1.5 1.5v10c0 .828-.672 1.5-1.5 1.5h-6.833L7.8 19.9c-.33.247-.8.012-.8-.4V17zm.5-7.5c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h9c.276 0 .5.224.5.5s-.224.5-.5.5h-9zm0 3c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h7c.276 0 .5.224.5.5s-.224.5-.5.5h-7z',
  transform: 'translate(-914 -160) translate(905 84) translate(9 76)',
});
